module.exports = function() {
  return new Worker(__webpack_public_path__ + "a577de580c089b4fd5f5.worker.js");
};